import { apiClient } from '../lib/api/client'
import type { OwnerInsert, OwnerUpdate, OwnerWithPropertyCount } from '../types'
import type {
  IPaginatedRepository,
  IPaginatedRepositoryResponse,
} from './types'

export interface OnwerFormData {
  email: string
  password?: string
  name: string
  phone?: string
}

export class OwnerRepository
  implements
    IPaginatedRepository<OwnerWithPropertyCount, OwnerInsert, OwnerUpdate>
{
  private functionName = 'owners'

  async getAll(options?: {
    search?: string
    page?: number
    limit?: number
    sortBy?: string
    sortOrder?: string
    showDeleted?: boolean
    id?: string
  }): Promise<IPaginatedRepositoryResponse<OwnerWithPropertyCount>> {
    const queryString = new URLSearchParams(
      options as Record<string, string>
    ).toString()
    return apiClient.invoke<
      IPaginatedRepositoryResponse<OwnerWithPropertyCount>
    >(`${this.functionName}?${queryString}`, {
      method: 'GET',
    })
  }

  async getById(id: string): Promise<OwnerWithPropertyCount> {
    return apiClient.invoke<OwnerWithPropertyCount>(
      `${this.functionName}?id=${id}`,
      {
        method: 'GET',
      }
    )
  }

  async create(data: OwnerInsert): Promise<OwnerWithPropertyCount> {
    const requestBody: any = {
      email: data.email,
      user_metadata: {
        name: data.name,
        phone: data.phone,
      },
    }

    // Only include password if provided
    if (data.password) {
      requestBody.password = data.password
    }

    return apiClient.invoke<OwnerWithPropertyCount>(this.functionName, {
      method: 'POST',
      body: requestBody,
    })
  }

  async update(id: string, data: OwnerUpdate): Promise<OwnerWithPropertyCount> {
    const requestBody: any = {
      email: data.email,
      user_metadata: {
        name: data.name,
        phone: data.phone,
      },
    }

    // Only include password if provided
    if (data.password) {
      requestBody.password = data.password
    }

    console.log({ id, ...requestBody })

    const updateOwner = await apiClient.invoke<OwnerWithPropertyCount>(
      this.functionName,
      {
        method: 'PUT',
        body: { id, ...requestBody },
      }
    )
    return updateOwner
  }

  async delete(id: string): Promise<void> {
    await apiClient.invoke<void>(`${this.functionName}?id=${id}`, {
      method: 'DELETE',
    })
  }

  async restore(id: string): Promise<void> {
    await apiClient.invoke<void>(`${this.functionName}?id=${id}`, {
      method: 'PATCH',
    })
  }
}

export const ownerRepository = new OwnerRepository()
